import { initRange as a } from "./init.js";
import { bisectRight as g } from "../../d3-array/src/bisect.js";
function l() {
  var r = [0.5], e = [0, 1], i, u = 1;
  function t(n) {
    return n != null && n <= n ? e[g(r, n, 0, u)] : i;
  }
  return t.domain = function(n) {
    return arguments.length ? (r = Array.from(n), u = Math.min(r.length, e.length - 1), t) : r.slice();
  }, t.range = function(n) {
    return arguments.length ? (e = Array.from(n), u = Math.min(r.length, e.length - 1), t) : e.slice();
  }, t.invertExtent = function(n) {
    var o = e.indexOf(n);
    return [r[o - 1], r[o]];
  }, t.unknown = function(n) {
    return arguments.length ? (i = n, t) : i;
  }, t.copy = function() {
    return l().domain(r).range(e).unknown(i);
  }, a.apply(t, arguments);
}
export {
  l as default
};
